var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconPresciption(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.64,
    height: 42.215,
    viewBox: "0 0 39.64 42.215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "medicine",
    transform: "translate(-15.601 0.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_264",
    "data-name": "Group 264",
    transform: "translate(23.904 10.335)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_263",
    "data-name": "Group 263",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1168",
    "data-name": "Path 1168",
    d: "M116.516,125.994a.82.82,0,1,0,.82.82A.821.821,0,0,0,116.516,125.994Z",
    transform: "translate(-115.696 -125.994)",
    fill: "#0060a6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_266",
    "data-name": "Group 266",
    transform: "translate(24.724 22.393)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_265",
    "data-name": "Group 265",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1169",
    "data-name": "Path 1169",
    d: "M133.078,276.267h-2.461v-2.461a.82.82,0,1,0-1.641,0v2.461h-2.461a.82.82,0,1,0,0,1.641h2.461v2.461a.82.82,0,1,0,1.641,0v-2.461h2.461a.82.82,0,1,0,0-1.641Z",
    transform: "translate(-125.696 -272.986)",
    fill: "#0060a6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_268",
    "data-name": "Group 268",
    transform: "translate(15.701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    "data-name": "Group 267"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1170",
    "data-name": "Path 1170",
    d: "M54.246,26.413a6.558,6.558,0,0,0-8.964-2.4L41.95,25.935V18.811a4.131,4.131,0,0,0-.82-2.461l-4.1-5.468V8.554a2.465,2.465,0,0,0,1.641-2.32V2.461A2.464,2.464,0,0,0,36.208,0H21.443a2.464,2.464,0,0,0-2.461,2.461V6.234a2.465,2.465,0,0,0,1.641,2.32v2.329l-4.1,5.469a4.13,4.13,0,0,0-.82,2.46V34.7a4.106,4.106,0,0,0,4.1,4.1H32.985a6.556,6.556,0,0,0,8.914,2.32l9.945-5.742A6.567,6.567,0,0,0,54.246,26.413ZM20.623,2.461a.821.821,0,0,1,.82-.82H36.208a.821.821,0,0,1,.82.82V6.234a.821.821,0,0,1-.82.82H21.443a.821.821,0,0,1-.82-.82V2.461ZM17.834,17.335,22.1,11.648a.82.82,0,0,0,.164-.492V8.695H35.387v1.641H28.005a.82.82,0,0,0,0,1.641H35.8l4.019,5.358a2.482,2.482,0,0,1,.475,1.2H17.359A2.481,2.481,0,0,1,17.834,17.335ZM19.8,37.158A2.464,2.464,0,0,1,17.342,34.7v-.828h14.9a6.573,6.573,0,0,0,.039,3.289H19.8Zm13.086-4.922H17.342V20.179H40.309v6.7l-4.973,2.871A6.514,6.514,0,0,0,32.888,32.237ZM41.079,39.7a4.922,4.922,0,1,1-4.922-8.524L40.609,28.6l4.922,8.524Zm9.945-5.742-4.072,2.351L42.03,27.782,46.1,25.432a4.921,4.921,0,1,1,4.922,8.524Z",
    transform: "translate(-15.701)",
    fill: "#f6781b",
    stroke: "#f6781b",
    strokeWidth: 0.2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPresciption);
export default __webpack_public_path__ + "static/media/icon_presciption.c897e030921b55d25490f478c6adf79d.svg";
export { ForwardRef as ReactComponent };